import { render, staticRenderFns } from "./AddSettlementItemCommentForm.vue?vue&type=template&id=726d6ed0&"
import script from "./AddSettlementItemCommentForm.vue?vue&type=script&lang=js&"
export * from "./AddSettlementItemCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports